import { FinanceTools } from "./finance-tools"

interface FinanceToolsContainerProps {}

export const FinanceToolsContainer: React.FC<FinanceToolsContainerProps> = (_props) => {

    return (
        <FinanceTools 
            glPostingSummaryData={null}
        />
    )

}